// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  leaseId: __t.u64().primaryKey().name("lease_id"),
  sigKey: __t.string().name("sig_key"),
  claimant: __t.identity(),
  systemId: __t.string().name("system_id"),
  kind: __t.string(),
  tenderId: __t.u64().name("tender_id"),
  shipId: __t.u64().name("ship_id"),
  reservedU: __t.u32().name("reserved_u"),
  bondSov: __t.i64().name("bond_sov"),
  mode: __t.string(),
  progressMs: __t.u32().name("progress_ms"),
  needMs: __t.u32().name("need_ms"),
  lastBeatAt: __t.timestamp().name("last_beat_at"),
  stepSeq: __t.u32().name("step_seq"),
  state: __t.string(),
  endReason: __t.string().name("end_reason"),
  expiresAt: __t.timestamp().name("expires_at"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
